import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { ENDPOINTS } from '../../config';
import client from '../../services/client';

// Define the initial state
const initialState = {
  data: [],
  status: 'idle',
  error: null,
};

// Create an asynchronous thunk to fetch the whitelist device data
export const fetchWhiteListDevice = createAsyncThunk(
  'whiteListDevice/fetchWhiteListDevice',
  async (id) => {
    
    const response = await client.get(`${ENDPOINTS.getDeviceWhitelist}?iccid=${id}`);
    return response;
  }
);

// Create the slice
const whiteListDeviceSlice = createSlice({
  name: 'whiteListDevice',
  initialState,
  reducers: {
    // Add any additional reducers here if needed
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchWhiteListDevice.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchWhiteListDevice.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
      })
      .addCase(fetchWhiteListDevice.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

// Export actions and reducer
export default whiteListDeviceSlice.reducer;
